module.exports = __webpack_public_path__ + "img/icon_unlock.3b40f307.svg";